import { assoc, omit } from 'ramda'
import { on, reducer as createReducer } from 'ts-action'

import { setUserAccessToken, clearUserAccessToken, setUserAccount, clearUserAccount } from './actions'
import { FEATURE_NAME } from './constants'

export interface State {
    userAccessToken?: string
    userAccount?: string
}

export interface GlobalState {
    [FEATURE_NAME]: State
}

export const initialState: State = {}

export const reducer = createReducer(
    initialState,
    on(setUserAccessToken, (state, { payload: { userAccessToken } }) =>
        assoc('userAccessToken', userAccessToken, state)
    ),
    on(clearUserAccessToken, state => omit(['userAccessToken'], state)),
    on(setUserAccount, (state, { payload: { userAccount } }) => assoc('userAccount', userAccount, state)),
    on(clearUserAccount, state => omit(['userAccount'], state))
)
